<div class="login-desktop text">
  <form class="login-form" [formGroup]="loginDatas">
    <div class="login-item">
      <input placeholder="{{ 'user_name' | t }}" type="text" formControlName="userName" class="login-input" />
    </div>
    <div class="login-item">
      <input placeholder="{{ 'password' | t }}" type="password" formControlName="userPassword" class="login-input" />
    </div>
  </form>
  <div class="item-row" *ngIf="isError">
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>
  <div class="item-row" *ngIf="isError">
    <div class="btn colored register-button login-dropdown-btn">
      <div class="contact-btn-text">
        {{ 'Contact' | t }}
      </div>
    </div>
  </div>
  <div class="item-row" (click)="submitLoginData()">
    <div class="btn colored blue login-dropdown-btn">
      <div class="login-button-text">{{ 'Login' | t }}</div>
    </div>
  </div>
</div>

<div class="login-mobile text">
  <div class="sidenav-header">
    <div class="left">{{ 'Login' | t }}</div>
    <div class="right" (click)="closeSideBar()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <form class="login-mobile-form" [formGroup]="loginDatas">
    <div class="login-item">
      <inputb3 formControlName="userName" fPlaceholder="{{ 'user_name' | t }}" fInputType="input_text"></inputb3>
    </div>
    <div class="login-item">
      <inputb3 formControlName="userPassword" fPlaceholder="{{ 'password' | t }}" fInputType="password" extraClass="loginPassword"></inputb3>
    </div>
  </form>
  <div class="login-container">
    <div class="login-row" *ngIf="isError">
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    <div class="login-row" (click)="submitLoginData()">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text">
          {{ 'Login' | t }}
        </div>
      </div>
    </div>

    <div class="login-row" *ngIf="isError">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text">
          {{ 'Contact' | t }}
        </div>
      </div>
    </div>
  </div>
</div>
